<template>
<div class="columns profile-container">
    <div v-if="!userProfile" class="profile-left col-md-4 col-lg-3 col-sm-12">
        <div class="user-profile">
            <b-icon v-if="!printscreenUrl" icon="card-account-details-star" size="is-large"></b-icon>
            <b-field class="file is-primary" :class="{'has-name': !!profileImageUpload}">
                <b-upload :native="true" @input="uploadProfileImage($event)" v-model="profileImageUpload" class="file-label" rounded>
                    <span class="file-cta">
                        <b-icon class="file-icon" icon="upload"></b-icon>
                        <span class="file-label">{{ profileImageUpload && profileImageUpload.name || "Upload profile image"}}</span>
                    </span>
                </b-upload>
            </b-field>

            <b-image
                rounded
                :src="printscreenUrl"
            ></b-image>

            
            <strong class="profile-username"> {{currentUser.username}}</strong>
            <strong class="profile-role" v-for="(role,index) in currentUser.roles" :key="index">{{roleByName(role)}}</strong>
            <span v-if="userInfo"> <b>{{ teamText }}</b> Team </span>
            <span style="text-align: center"> Start date: <br> {{ startDate }} </span>

            <div class="actions">
                <b-button @click="changePass(currentUser.id, currentUser.username)" type="is-primary">Change password</b-button>
                <b-button v-if="userTeam.name" @click="toggleTeamChange()" type="is-primary" class="mt-2">{{ requestTeamChangeText }}</b-button>
                <b-button @click.prevent="logOut()" type="is-primary" class="mt-2">LogOut</b-button>
                <b-button v-if="currentUser.completedTutorial !== true" @click="completeTutorial()" type="is-primary" class="mt-2">Complete tutorial</b-button>
            </div>
        </div>
    </div>

    <div :class="userProfile ? 'col-md-12 col-lg-12 col-sm-12' : 'col-md-8 col-lg-9 col-sm-12'">
        <div class="user-profile personal-info">
            <strong class="personal-info-title"> General Info</strong>
            <p><b>Gender:</b> {{currentUser.templateOptions.gender}}</p>
            <p><b>Phone no:</b> {{ currentUser.templateOptions.phone_number}}</p>
            <p><b>Personal email address:</b> {{ currentUser.templateOptions.email }}</p>
            <p><b>Work email address:</b> {{ currentUser.templateOptions.work_email }}</p>
            <p>
                <b>Address:</b>
                {{ currentUser.templateOptions.street_address + " " + currentUser.templateOptions.house_number + " " + currentUser.templateOptions.city + " " + currentUser.templateOptions.zip_code + " " }}
            </p>
        </div>

        <div class="user-profile personal-info">
            <strong class="personal-info-title edit-title"> Bank details
                <b-icon v-if="!userProfile" @click.native.prevent="redirectToTutorial()" icon="pencil-box"></b-icon>
            </strong>
            <p><b>Account name:</b> {{ currentUser.templateOptions.financial.account_name }}</p>
            <p><b>Account No. :</b> {{ currentUser.templateOptions.financial.account_no }}</p>
            <p><b>Sort code:</b> {{ currentUser.templateOptions.financial.short_code }}</p>
            <p><b>National Insurance no. :</b> {{ currentUser.templateOptions.financial.national_ins_no }}</p>
            <p><b>UTR No.:</b> {{ currentUser.templateOptions.financial.utr_no }}</p>
            <p><b>UK SETTLEMENT STATUS:</b> {{ currentUser.templateOptions.financial.uk_settlement_status }}</p>
            <p><b>Share Code</b> {{ currentUser.templateOptions.financial.share_code }}</p>
        </div>

        <div class="user-profile personal-info">
            <strong class="personal-info-title edit-title"> Contract</strong>
            <p>
                <b-icon icon="check-decagram" type="is-success"></b-icon> <b>Job Description and Responsabilieties</b>
            </p>
            <p>
                <b-icon icon="check-decagram" type="is-success"></b-icon> <b>Confidentiality and Non-Disclosure of Student personal data</b>
            </p>
            <p>
                <b-icon icon="check-decagram" type="is-success"></b-icon> <b>Payment</b>
            </p>
            <p>
                <b-icon icon="check-decagram" type="is-success"></b-icon> <b>Terms of Termination</b>
            </p>
            <p>
                <b-icon icon="check-decagram" type="is-success"></b-icon> <b>Contract</b>
            </p>
        </div>

        <div v-if="userProfile" class="user-profile personal-info">
            <strong class="personal-info-title edit-title"> Marks on the test </strong>
            <p><b>User got the final mark as :</b> {{ currentUser.templateOptions.tutorialMark }}</p>
            <p>These are all the previous marks</p>

            <p v-for="(mark, index) in currentUser.templateOptions.userTestAnswers" :key="index">
                {{ `${index+1}.  ${ mark.question }` }}
                <b> Answer: {{ mark.answer }} </b>
            </p>
        </div>
    </div>

    <div v-if="passwordChangeUserId">
        <change-pass :userIdPass="passwordChangeUserId" :username="passwordChangeUsername" @closeChangePass="changePass(null, null)"></change-pass>
    </div>
</div>
</template>

<style>
.profile-container {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    margin-top: 69px;

    overflow: scroll;
    padding-bottom: 40px;
}

.profile-left {
    box-shadow: rgba(17, 12, 46, 0.15) 0px 48px 100px 0px;
    padding: 0;
    padding-left: 50px;
}

.user-profile {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    /* border: 2px solid grey; */
    border-radius: 8px;
    margin-top: 40px;

    box-shadow: rgba(249, 176, 64, 0.4) -5px 5px, rgba(249, 176, 64, 0.3) -10px 10px, rgba(249, 176, 64, 0.2) -15px 15px, rgba(249, 176, 64, 0.1) -20px 20px, rgba(249, 176, 64, 0.05) -25px 25px;
}

.user-profile .actions {
    display: flex;
    flex-direction: column;
}

.user-profile.personal-info {
    width: fit-content;
    align-items: flex-start;
}

.personal-info-title {
    font-size: 24px;
    color: #ffc451;
}

.personal-info>p {
    font-style: italic;
}

.personal-info>p>b {
    font-style: normal;
    margin-right: 12px;
}

.profile-username {
    font-size: 20px;
    color: rgba(249, 176, 64, 1);
}

.profile-right {
    display: flex;
    flex-wrap: wrap;
}

.contract-content>p {
    display: flex;
    align-items: center;
}

.edit-title .icon {
    cursor: pointer;
}
</style>

<script>
import ChangePass from './helpers/ChangePass.vue'
import UserService from '../services/user.service';
import TeamService from '../services/team.service'
import moment from 'moment';
import StudentService from "../services/student.service";

export default {
    name: 'Profile',
    props: ['userProfile'],
    data() {
        return {
            passwordChangeUserId: null,
            passwordChangeUsername: null,
            requestedTeamChange: false,
            teams: [],
            userTeam: {
                name: null
            },
            profileImageUpload: null,
            printscreenUrl: null,
            currentUser: null
        }
    },
    components: {
        ChangePass
    },
    computed: {
        computedUser() {
            return this.$store.state.auth.user;
        },
        requestTeamChangeText() {
            return this.requestedTeamChange === true ? 'Cancel team change' : 'Request team change'
        },
        teamText() {
            return this.userTeam.name ? this.userTeam.name : 'Not part of a team'
        },
        startDate() {
            return this.currentUser.createdAt ? moment(this.currentUser.createdAt).format('LL') : 'Invalid Date'
        },
        userInfo() {
            if (this.$store.state.auth.user.templateOptions && 'userInfo' in this.$store.state.auth.user.templateOptions) {
                return this.$store.state.auth.user.templateOptions.userInfo
            }

            return false
        },

        heShe() {
            return this.currentUser.templateOptions.gender === 'Male' ? 'He' : 'She'
        }
    },

    created() {
        this.currentUser = this.userProfile && this.userProfile.templateOptions ? this.userProfile : this.computedUser
    },

    mounted() {
        if (!this.currentUser) {
            this.$router.push('/login');
        }
        this.getTeams()
        this.requestedTeamChange = this.currentUser.requestedTeamChange
        this.printscreenUrl = this.currentUser.profileImage
    },
    methods: {
        logOut() {
            this.$store.dispatch('auth/logout');
            this.$router.push('/login');
        },
        roleByName(role) {
            switch (role) {
                case 'ROLE_ADMIN':
                    return 'admin'

                case 'ROLE_MODERATOR':
                    return 'moderator'

                default:
                    return 'Student Advisor'
            }
        },

        changePass(userId, username) {
            this.passwordChangeUserId = userId
            this.passwordChangeUsername = username
        },

        uploadProfileImage(event) {
            var reader = new FileReader();
            reader.readAsDataURL(event);

            const userId = this.currentUser.id
            reader.onload = () => {
                StudentService.uploadProfileImage({
                    dataURI: reader.result,
                    userId
                }).then((response) => {
                    this.printscreenUrl = response.data.printscreenUrl
                    this.$store.dispatch('auth/setProfileImage', response.data.printscreenUrl);
                    this.profileImageUpload = null
                    this.$buefy.toast.open({
                        duration: 3000,
                        message: `Please logout and login again`,
                        position: 'is-bottom',
                        type: 'is-success'
                    })
                })
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
            };
        },

        toggleTeamChange() {
            const requestedTeamChange = this.currentUser.requestedTeamChange === null ? true : !this.currentUser.requestedTeamChange;

            UserService.toggleTeamChange({
                    id: this.currentUser.id,
                    requestedTeamChange: requestedTeamChange
                })
                .then(() => {
                    const textToShow = requestedTeamChange ? 'submitted' : 'cancelled'
                    this.$store.dispatch('auth/setUserTeamChangeStatus', requestedTeamChange);
                    this.requestedTeamChange = requestedTeamChange

                    this.$buefy.toast.open({
                        duration: 3000,
                        message: `Request for changing the team was ${textToShow}`,
                        position: 'is-bottom',
                        type: 'is-success'
                    })
                })
        },

        getTeams() {
            TeamService.getTeams().then((response) => {
                this.teams = response.data
                if (this.currentUser.teamId) {
                    this.userTeam = response.data.filter(team => team.id === this.currentUser.teamId)[0]
                }
            })
        },

        completeTutorial() {
            UserService.agreeToTerms({
                id: this.currentUser.id
            }).then(() => {
                this.$buefy.toast.open({
                    duration: 3000,
                    message: `Completed tutorial`,
                    position: 'is-bottom',
                    type: 'is-success'
                })
            })
        },

        redirectToTutorial() {
            const userData = {
                ...this.currentUser.templateOptions,
                completedRegistration: false
            }
            this.$store.dispatch('auth/setUserTemplateOptions', userData);
            this.$store.dispatch('auth/userEditingData');
            this.$router.push('/tutorial');
        }
    }
};
</script>
